// extracted by mini-css-extract-plugin
export default {"root":"Tree_root__olGyF","tree":"Tree_tree__10P2H"};